<template>
    <QrWrapper>
        <div class="h-full flex flex-col max-w-xl mx-auto">
            <div class="flex mt-24">
                <LogoImage full class="mx-auto h-16 mb-4"/>
            </div>

            <QrForm @submit.prevent="forgotPassword" class="space-y-4 px-6 py-5 sm:p-6 mt-2">
                <Message
                    v-if="success"
                    info
                    :header="trans('message.an-email-with-a-password-reset-link-has-been-sent')"
                    header-trans="message.an-email-with-a-password-reset-link-has-been-sent"
                />

                <QrInput v-model="email" :label="trans('input.email')" type="email" :errors="validationErrors.email"/>

                <div class="flex justify-between space-x-4">
                    <QrLink to="/login" :text="trans('button.go-back')" trans="button.go-back" icon="arrow-left" secondary class="mt-1"/>
                    <QrButton
                        type="submit"
                        :loading="loading"
                        :recently-failed="recentlyFailed"
                        :recently-succeeded="recentlySucceeded"
                        :text="trans('button.reset-password')" trans="button.reset-password"
                        icon-right="arrow-right"
                    />
                </div>
            </QrForm>
        </div>
    </QrWrapper>
</template>

<script setup>
import QrInput from "@/components/application-ui/form/QrInput.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import { onMounted, ref } from "vue";
import { trans } from "@/libs/helper.js";
import { useUserStore } from "@/store/user.js";
import { useStatesStore } from "@/store/states.js";
import { storeToRefs } from "pinia";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import QrLink from "@/components/application-ui/content/QrLink.vue";
import Message from "@/components/application-ui/feedback/Message.vue";
import QrWrapper from "@/components/application-ui/panels/QrWrapper.vue";
import LogoImage from "@/components/LogoImage.vue";
import { useRoute, useRouter } from "vue-router";

const userStore = useUserStore();
const satesStore = useStatesStore();
const route = useRoute();
const router = useRouter();

const email = ref('');
const success = ref(false);
const { loading, recentlySucceeded, recentlyFailed, validationErrors } = storeToRefs(satesStore);
const { user } = storeToRefs(userStore);

const forgotPassword = async () => {
    success.value = false;

    await userStore.forgotPassword({ email: email.value }, () => {
        success.value = true;
    });
};

onMounted(async () => {
    if (user.value) {
        if (route.query.redirect === '/') {
            await router.push('/dashboard');
        }

        await router.push(route.query.redirect || '/dashboard');
    }
});
</script>
